import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem } from 'primeng/primeng';
import { ToastrService } from 'ngx-toastr';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { QueryInterface } from 'app/shared/common/parse/query-interface';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-work-log',
  templateUrl: './work-log.component.html',
  styleUrls: ['./work-log.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
  ]
})

export class WorkLogComponent implements OnInit {
  selectedDate: Date;
  objId = '';
  worklogArray = [];
  workId: any;
  sumOfHours = '00:00:00';
  worklog = [];
  totalWorkingHrs: any
  selectbydate = new Date();
  last15days = [];
  isEdit: boolean;
  objectId = '';
  empRole = '';
  @Input() projectId: any;
  graphValue: any;
  workDetail = [];
  totalWorkHours = '';
  date = new FormControl(moment());
  fromDate: any;
  toDate: any;
  options: any;
  departmentList = [];
  department = [];
  deptOptions: SelectItem[];
  deptDD = [];
  cols: any[];
  projectType: any;
  projectEstimatedHours: any;
  estimatedHours: any;
  graphData = [];
  view: any[] = [550, 400];

  // options
  showLegend: boolean = true;
  showLabels: boolean = true;

  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };
  public barChartLabels = [];
  public barChartData = [];
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    animation: {
      onComplete: function () {
        var chartInstance = this.chart,
          ctx = chartInstance.ctx;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
        this.data.datasets.forEach(function (dataset, i) {
          var meta = chartInstance.controller.getDatasetMeta(i);
          meta.data.forEach(function (bar, index) {
            var data = dataset.data[index];
            ctx.fillText(data, bar._model.x, bar._model.y - 5);
          });
        });
      }
    },
    responsive: true,
    options: {
      scales: {
        yAxes: [{
          ticks: {
            reverse: false,
            stepSize: 50
          },
        }]
      }
    }
  };
  public barChartType: string = 'bar';
  public barChartLegend: boolean = false;
  public barChartColors = [
    '#64B5F6',
    '#76D7C4',
    '#B39DDB',
    '#FF8A7E',
    '#FF87AB',
    '#F18EE1',
    '#72AEFF',
    '#3AC5DE',
    '#46C7A8',
    '#68C17A',
    '#99B65F',
    '#D1A656',
  ];
  tenantId: any;
  tenantRole: any;
  tenantDepartment: any;

  constructor(
    private parseService: ParseService,
    private route: ActivatedRoute,
    private storageConfiguration: StorageConfiguration,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
    private getReportingToService: GetReportingToService,
    private queryInterface: QueryInterface
  ) {

    this.cols = [
      { header: 'S.No', field: 'position' },
      { header: 'Resource Name', field: 'name' },
      { header: 'Department', field: 'userDepartment' },
      { header: 'Total Work Hours', field: 'workHours' }
    ];

  }

  /*
  ** ==========================================================
  ** On Init
  ** ==========================================================
  */
  ngOnInit() {
    this.getDepartment();
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.isEdit = false;
    this.getTenantDepartment();
    this.getTenantRole();
    this.route.params.subscribe(params => {
      this.objectId = params['id'];
      let events = params['events'];
      this.objectId = events == undefined ? this.objectId : events;
      if (this.objectId != '' && this.objectId != undefined) {
        this.isEdit = true;
      }
    });
    this.objectId = this.projectId;
    this.worklogArray = [];
    let today = new Date();
    let date = new Date().getDate() >= 10 ? new Date() : new Date(today.getFullYear(), today.getMonth(), 0);
    let startendDates = this.startenddates(date);
    this.getAssignedResourceId(startendDates);

    this.options = {
      legend: {
        position: 'top'
      }
    };
  }

  /*
  ** ==========================================================
  ** Apply Filter
  ** ==========================================================
  */
  clearFilter() {
    let today = new Date();
    let date = new Date().getDate() >= 10 ? new Date() : new Date(today.getFullYear(), today.getMonth(), 0);
    let startendDates = this.startenddates(date);
    this.getAssignedResourceId(startendDates);
  }

  monthSelector(event): void {
    let startendDates = this.startenddates(event);
    this.getAssignedResourceId(startendDates);
  }

  getRangeValue() {
    var d = new Date();
    let yesterday = new Date(d.setDate(d.getDate() - 1));
    if (this.fromDate == undefined) {
      this.toastr.warning('Please select the start date');
    } else {
      let startDate = this.startenddates1(this.fromDate);
      let endDate = this.startenddates1(this.toDate == undefined ? new Date(yesterday) : this.toDate);
      let startEndDate = [startDate[0], endDate[1]];
      this.getAssignedResourceId(startEndDate);
    }
  }

  /*
  ** ==========================================================
  ** Get assigned resource details
  ** ==========================================================
  */
  getAssignedResourceId(startendDates) {
    this.getProjectEstimatedHours();
    let membersIds = [];
    let projectId = this.empRole == 'Admin' ? this.objectId : this.objectId;
    let projectMember = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(projectMember);
    query.include('project');
    query.include('user');
    query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: projectId });
    query.find().then(members => {
      members.forEach(element => {
        membersIds.push(element.get('user').id);
      });
      let ids = this.uniqBy(membersIds, JSON.stringify);
      this.getTimeSheetDetails(ids, startendDates);
    });
  }

  getProjectEstimatedHours() {
    let projectMember = this.parseService.instance.Object.extend('Project');
    let query = new this.parseService.instance.Query(projectMember);
    query.equalTo('objectId', this.objectId);
    query.find().then(res => {
      this.projectType = res[0].get('projectInfo').projectType;
      if (this.projectType == 'Fixed') {
        this.estimatedHours = res[0].get('resourceDetails').details;
        this.projectEstimatedHours = this.getHoursCount();
      }
    });
  }

  getHoursCount() {
    let total = 0;
    this.estimatedHours.forEach(element => {
      total += element.hours;
    });
    return total;
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  /*
  ** ==========================================================
  ** Get timesheet details
  ** ==========================================================
  */
  getTimeSheetDetails(membersIds, startendDates) {
    this.spinner.show();
    let timeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(timeSheet);
    query.include('user');
    query.include('user.profile');
    query.include('user.profile.department');
    query.greaterThan('createdAt', startendDates[0]);
    query.lessThan('createdAt', startendDates[1]);
    query.containedIn('user', membersIds);
    query.equalTo('tenantId', this.tenantId);
    query.limit(1000000);
    query.find().then(results => {
      let data = [];
      let total = 0;
      let workDetails = [];
      let projectId = this.empRole == 'Admin' ? this.objectId : this.objectId;
      membersIds.forEach(async id => {
        let timeSheets = results.filter(x => x.get('user').id == id);
        let workHours = 0;
        let userName = '';
        let userDepartment = '';

        if (timeSheets.length > 0) {
          // timeSheets.forEach(tSheet => {
          for (let tSheet of timeSheets) {
            let userProfile = tSheet.get('user').get('profile');
            userName = userProfile.get('firstName') + ' ' + userProfile.get('lastName');
            let department = userProfile.get('department');
            userDepartment = this.getReportingToService.getDepartmentDisplayName(department.get('name'));

            let totalAttendance = tSheet.get('totalAttendance');
            let workDatas = totalAttendance.project.filter(a => a.id == projectId);
            workDatas.forEach(workData => {
              workHours += workData.actualHours;
            });

          }
          if (workHours > 0) {
            workDetails.push({ position: 0, name: userName, id: id, workHours: workHours, userDepartment: userDepartment });
          }
        }
      });
      this.detailsToGraph(workDetails);
      this.workDetail = workDetails.sort(function (a, b) { return b.workHours - a.workHours });
      let totalHrs = 0;
      this.workDetail.forEach((element, index) => {
        element.position = index + 1;
        totalHrs += element.workHours;
        element.workHours = this.secondsToHms(Math.ceil(element.workHours / 1000));
      });
      this.totalWorkHours = this.secondsToHms(Math.ceil(totalHrs / 1000));
      this.spinner.hide();

    });
  }

  detailsToGraph(workDetails) {
    let names = [];
    let workHrs = [];
    this.graphData = [];
    this.barChartData = [];
    workDetails.forEach(element => {
      names.push(element.name);
      workHrs.push(Math.round(Math.ceil(element.workHours / 1000) / 3600));
      this.graphData.push({
        name: element.name,
        value: Math.round(Math.ceil(element.workHours / 1000) / 3600)
      });
    });

    this.barChartLabels = names;
    this.barChartData.push({
      label: 'Work Hours',
      data: workHrs,
      backgroundColor: this.barChartColors,
    });

    this.graphValue = {
      labels: names,
      datasets: [
        {
          data: workHrs,
          backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#FAEBD7',
            '#C70039',
            '#581845',
            '#6133FF',
            '#33FF6B',
            '#800000',
            '#FF0000',
            '#FFA500',
            '#FFFF00',
            '#808000',
            '#800080',
            '#FF00FF',
            '#00FF00',
            '#008080'
          ],
          hoverBackgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#FAEBD7',
            '#C70039',
            '#581845',
            '#6133FF',
            '#33FF6B',
            '#800000',
            '#FF0000',
            '#FFA500',
            '#FFFF00',
            '#808000',
            '#800080',
            '#FF00FF',
            '#00FF00',
            '#008080'
          ]
        }]
    };
  }

  /*
  ** ==========================================================
  ** Get department details
  ** ==========================================================
  */
  async getDepartment() {
    await this.getReportingToService.getDepartment().then(res => {
      this.deptOptions = this.bindDropDown(res);
    });
  }

  /*
  ** ==========================================================
  ** Bind dropdown
  ** ==========================================================
  */
  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.label, value: a.label });
    });
    return dropDownItem;
  }

  getToday(): Date {
    return new Date(Date.now() - 864e5);
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    // var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay;
  }

  nextMnth(d) {
    let day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth() + 1, 1);
  }

  prevMnth(d) {
    let day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth(), 0);
  }

  startenddates(day) {
    let startdate = this.prevMnth(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate: Date;

    if (day.getMonth() !== new Date().getMonth()) {
      enddate = this.nextMnth(day);
      enddate.setHours(0, 0, 0, 0);
    } else {
      enddate = new Date();
      enddate.setHours(0, 0, 0, 0);
    }

    return [startdate, enddate];
  }

  nextDay(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() + 1));
  }

  prevDay(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() - 1));
  }

  startenddates1(day) {
    let startdate = this.prevDay(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.nextDay(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

  // Completed //

  onResize(event) {
    this.view = [event.target.innerWidth / 3.05, 400];
  }

  async getTenantRole(): Promise<void>{
    this.tenantRole = await this.getReportingToService.getTenantRole(this.tenantId);
  }

  async getTenantDepartment(): Promise<void>{
   this.tenantDepartment = await this.getReportingToService.getTenantDepartment(this.tenantId);
  }

}
